<template>
    <div>
       <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Order Types</template>
        </page-header>

        <div class="px-6 pt-2">
            <div class="flex justify-start mt-2 flex-wrap">
                <div class="relative pr-4 mb-3 w-1/2">
                    <input-select class="sm:col-span-4"
                        label="Group"
                        placeholder="Select Group"
                        name="selectedGroup"
                        v-model="selectedGroup"
                        return="value"
                        :options="options.groups"
                        @input="onSelectGroup"/>
                </div>
            </div>
        </div>

        <div class="px-6 pt-2" v-if="selectedGroup">
            <div class="flex justify-start mt-2 flex-wrap">
                <div class="relative pr-4 mb-3 w-1/2">
                    <label class="block w-full text-sm pb-1">Types
                        <span><font-awesome-icon class="text-sm text-sm ml-2" style="top: 12px; cursor: pointer;" tooltip="Sort By Name" :icon="['fas', 'sort-up']" v-on:click="onAscending" /></span>
                        <span><font-awesome-icon class="text-sm text-sm ml-2" style="top: 12px; cursor: pointer;" tooltip="Reset" :icon="['fas', 'undo']" v-on:click="onReset" /></span>
                    </label>
                    <ul class="list-group list-reset">
                        <draggable :list="selectedTypes">
                            <li v-for="(type, index) in selectedTypes" v-bind:key="index" class="cursor-move border border-gray-500 py-1 px-2 mb-2 bg-gray-200 text-sm" draggable="true" v-on:dragstart="dragstart(type, $event)" v-on:dragend="dragend($event)">
                                <div class="relative pr-4 mb-3 inline">{{ type.name }}</div><div class="relative pr-4 mb-3 float-right">({{ type.ordering ? type.ordering : 'N/A' }})</div>
                                <!-- {{ type.name }} -->
                            </li>
                        </draggable>
                    </ul>
                </div>
            </div>
        </div>


        <!-- <div class="px-6 pt-2" v-if="selectedTypes.length > 0">
            <div class="flex justify-start mt-2 flex-wrap">
                <div class="relative pr-4 mb-3 w-1/4">
                    <label class="block w-full text-xs pb-1 font-semibold">Types</label>
                    <ul class="list-group list-reset">
                        <li v-for="(type, index) in options.types.filter(t => t.group == selectedGroup)" v-bind:key="index" class="cursor-move border py-1 px-2 mb-2 bg-grey-lighter"
                            draggable="true" v-on:dragstart="dragstart(type, $event)" v-on:dragend="dragend($event)">
                            <strong>{{ type.name }}</strong> {{ type.group_name }}, {{ type.ordering }}
                        </li>
                    </ul>
                </div>
            </div>
        </div> -->

    </div>
</template>
<script>
    import axios from "axios";
    import draggable from 'vuedraggable';

    export default {
        name: 'TypeOrdering',
        components: {
            draggable
        },
        data: function(){
            return {
                pageActions: {
                    buttons: [
                        {
                            label: 'Cancel',
                            icon: 'times',
                            iconClass: 'text-red-600',
                            type: 'method',
                            method: 'cancel'
                        },
                        {
                            label: 'Apply',
                            icon: 'check',
                            iconClass: 'text-green-600',
                            type: 'method',
                            method: 'apply'
                        }
                    ]
                },
                options: {
                    groups: [],
                    types: []
                },
                selectedGroup: null,
                selectedTypes: [],
                dragging: false

            }
        },
        beforeMount() {
            this.getData();
        },
        mounted() {
            this.$Progress.finish();
        },
        methods: {

            // Get groups and types
            getData: function(){
                axios.get(process.env.VUE_APP_API_URL + '/types/form-data')
                .then(response => {
                    // Groups
                    this.options.groups = response.data.groups.map(function (group) {
                        return { label: group.group_name, value: group.group };
                    });

                     // Types
                    this.options.types = response.data.types.map(function (type) {
                        return { id: type.id, name: type.name, group: type.group, group_name: type.group_name, ordering: type.ordering };
                    });

                    this.$Progress.finish();
                })
                .catch(() => {
                    this.$Progress.finish();
                });
            },
            methodHandler: function(method){
                this[method]();
            },
            dragstart: function(item, e) {
                this.$emit('redrag', item);
                e.target.style.opacity = 0.5;
                // e.dataTransfer.setData('text/plain', 'type');
            },
            dragend: function(e) {

                e.target.style.opacity = 1;
                this.setOrder();

            },
            onSelectGroup: function(){
                if (this.selectedGroup){
                    this.selectedTypes = this.options.types.filter(t => t.group === this.selectedGroup);
                    // this.setOrder();
                } else {
                    this.selectedTypes = [];
                    return null;
                }
            },
            onAscending: function() {

                this.selectedTypes.sort(function (a, b) {
                        if (a.name < b.name) return -1;
                        if (b.name < a.name) return 1;
                        return 0;
                    });

                this.setOrder();

            },
            onReset: function(){
                this.selectedTypes = this.options.types.filter(t => t.group === this.selectedGroup);
                this.setOrder();
            },
            setOrder: function(){

                // set the ordering on the elements
                this.selectedTypes.forEach((t, index) => {
                    t.ordering = (index + 1);
                });

            },
            cancel: function(){
                this.$router.push('/configuration/types');
            },
            apply: function(){

                // set backdrop
                this.$store.commit('TOGGLE_BACKDROP', { open: true });

                if(this.selectedTypes.some(t => t.ordering === '')){
                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'error',
                        title: 'Warning',
                        text: 'Object has no order',
                        duration: 5000
                    });

                    this.$store.commit('TOGGLE_BACKDROP', { open: false });
                    return;
                }


                axios.post(process.env.VUE_APP_API_URL + '/ordering', {
                    orderingType: 'types',
                    orderingData: this.selectedTypes
                }).then(response => {

                    this.$store.commit('TOGGLE_BACKDROP', { open: false });

                    if (response.data.success){
                        this.$notify({
                            group: 'main',
                            position: 'bottom right',
                            type: 'success',
                            title: 'Success',
                            text: response.data.message,
                            duration: 5000
                        });
                    }

                }).catch(() => {
                    this.$store.commit('TOGGLE_BACKDROP', { open: false });
                });
            }

        },
        computed: {
            // groupValue: function(){
            //     if (this.selectedGroup){
            //         this.selectedTypes = this.options.types.filter(t => t.group == this.selectedGroup);
            //         // this.setOrder();
            //         return {label: '', value: this.selectedGroup  };
            //     } else {
            //         this.selectedTypes = [];
            //         return null;
            //     }
            // },
            // selectedTypes: function(){
            //     console.log('selectedTypes');
            //     if (this.selectedGroup){
            //        return this.options.types.filter(t => t.group == this.selectedGroup);
            //     } else {
            //         return [];
            //     }
            // },

        }
    }
</script>
